export function isThereServiceArea(data) {
    if (data && data !== "null") {
        return true;
    } else {
        return false;
    }
}